<template>
    <div class="order">
        <div class="top">
            <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-bottom: 4.8vw;">
                <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
                <el-breadcrumb-item>Order</el-breadcrumb-item>
            </el-breadcrumb>
            <div style="display: flex;justify-content: space-between;">
                <div class="filter" @click="drawer = true">
                    <p v-if="fiforckd == false">Filter</p>
                    <p v-else>Checked</p>
                    <img src="../assets/imgs/uploads/mobile/mdi_filter.png" alt="">
                </div>
                <el-select class="sort" v-model="valuesort" placeholder="Sort by..." :popper-append-to-body="false"
                transfer="true" @change="getGoodsList">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <!-- <div class="sort">
                    <p>Sort by...</p>
                    <i style="color: #000;" class="el-icon-arrow-down"></i>
                </div> -->
            </div>

        </div>
        <el-drawer title="Filter By" :modal="false" :size="drawerWidth" direction="ltr" :visible.sync="drawer">
            <div style="padding: 0 8vw 26.667vw;">
                <div class="title" style="margin-top: 0;">{{ $t('list.ordertype') }}</div>
                <el-radio-group v-model="checkedOrderType" style="margin-left: 5.333vw;">
                    <el-radio :label="0" style="margin-bottom: 4.8vw;" @click.native.prevent="cancel(0)">In Stock</el-radio>
                    <br>
                    <el-radio :label="1" style="margin-bottom: 4.8vw;"
                        @click.native.prevent="cancel(1)">Pre-Order</el-radio>
                    <br>
                    <el-radio :label="2" @click.native.prevent="cancel(2)">Group Buying</el-radio> <br>
                </el-radio-group>

                <div class="title">Tag</div>
                <el-checkbox-group v-model="tag" style="margin-left: 5.333vw;" @change="getGoodsList">
                    <el-checkbox :label="1" style="margin-bottom: 4.8vw;">Sale</el-checkbox>
                    <br>
                    <el-checkbox :label="2" style="margin-bottom: 4.8vw;">New</el-checkbox>
                    <br>
                    <el-checkbox :label="3" style="margin-bottom: 4.8vw;">Hot</el-checkbox>
                    <br>
                    <el-checkbox :label="4">PURCHASED</el-checkbox> <br>
                </el-checkbox-group>

                <div class="title">{{ $t('list.brands') }}</div>
                <el-checkbox-group v-if="this.$store.getters.getUser" style="margin-left: 5.333vw;"
                    v-model="brandCheckedList" @change="getGoodsList">
                    <el-checkbox v-for="(brand, index) in brands" :key="index" class="brand-item"
                        :label="brand.brand"></el-checkbox>
                </el-checkbox-group>
                <el-checkbox-group v-else v-model="brandCheckedList" @change="getGoodsList" style="margin-left: 5.333vw;">
                    <el-checkbox v-for="(brands1, index) in brands1" :key="index" class="brand-item"
                        :label="brands1.brand"></el-checkbox>
                </el-checkbox-group>
                <el-checkbox-group v-model="categoryCheckedList" @change="getGoodsList">
                    <div v-for="category in categories" :key="category.id" style="margin-bottom: 2.667vw;">
                        <div style="font-size: 4.267vw; font-weight: bold; margin-bottom: 2.667vw;">{{ category.categoryName
                        }}
                        </div>
                        <el-checkbox style="margin-left: 5.333vw;" v-for="subCategory in category.children"
                            :key="subCategory.id" class="category-item" :label="subCategory.id">{{ subCategory.categoryName
                            }}</el-checkbox>
                    </div>
                </el-checkbox-group>
                <div class="filterbtn">
                    <div class="left" @click="clearFilters">Clear filters</div>
                    <div class="right" @click="drawer = false">View Results</div>
                </div>
            </div>
        </el-drawer>
        <div style="padding: 4.8vw 7.467vw;margin-top: 28vw;">
            <div id="top1"></div>
            <div v-if="loading" style="text-align: center">
                <img src="../assets/imgs/uploads/Animation.gif" alt="">
            </div>
            <div v-else-if="shoppingCart.length > 0">
                <div style="display: flex;justify-content: start;color: #959595;margin-bottom: 4.8vw;">Display
                    <span style="font-weight: bold;margin: 0 5px;color: #333;">{{ total }}</span>results
                </div>
                <div style="display: flex;flex-wrap: wrap;">
                    <div class="toysItem" v-for="(item, index) in shoppingCart" :key="index">
                        <div v-if="item.isBuy == true && item.tag !== 0" class="Purchased">PURCHASED</div>
                        <div v-if="item.isBuy == true && item.tag == 0" class="Purchased"
                            style="left: 0;padding-left: 0;width: 23.733vw;">PURCHASED</div>
                        <div v-if="item.tag == 1" class="off">{{ item.discount * 100 }}% OFF
                        </div>
                        <div v-if="item.tag == 2" class="NEW">NEW</div>
                        <div v-if="item.tag == 3" class="NEW" style="background-color: #FFC700;">HOT</div>
                        <!-- <div v-if="item.discount !== null && item.discount !== ''" class="off">{{ item.discount * 100 }}%
                            OFF
                        </div>
                        <div v-if="item.tag == 2" class="NEW">NEW</div>
                        <div v-if="item.tag == 3" class="NEW" style="background-color: #FFC700;">HOT</div> -->
                        <div class="tp">
                            {{ getLabelForStatus(item.proType) }}
                        </div>
                        <router-link :to="{ path: '/detail', query: { spuId: item.spuId } }">
                            <img v-lazy="item.imageUrl" alt=""
                                style="width: 40.125vw;height: 36.539vw;border-radius: 3.2vw 3.2vw 0 0;">
                            <div class="skuname">
                                <span style="font-size: 3.467vw;">{{ item.skuName }}</span>
                            </div>
                        </router-link>
                        <div class="parameterItem">
                            <p style="text-align: center;">MOQ / Consolidation</p>
                            <p style="text-align: center;font-size: 3.733vw;color: #000;">{{ item.amount }} / {{ item.isLcl
                                === 0 ? $t('table.no') : $t('table.yes') }}</p>
                        </div>
                        <div class="parameterItem">
                            <p style="text-align: center;">{{ $t('table.price') }}</p>
                            <p style="text-align: center;font-size: 3.733vw;color: #000;">${{ item.price }}</p>
                        </div>
                        <div style="margin-top: 2.909vw;text-align: center;">
                            <el-input-number v-if="item.isLcl === 0" style="width: 30.573vw;" :step="item.amount"
                                size="mini" :value="item.memberNum ? item.memberNum : 0"
                                @change="handleChange($event, index, item.skuId)" :min="0" :max="item.stockNum"
                                step-strictly></el-input-number>

                            <el-input-number v-else style="width: 30.573vw;" size="mini"
                                :value="item.memberNum ? item.memberNum : 0"
                                @change="handleChange($event, index, item.skuId)" :min="0"
                                :max="item.stockNum"></el-input-number>
                        </div>
                        <div
                            style="margin-top: 3.872vw;padding: 0 5.147vw 0 4.893vw;display: flex;justify-content: space-between;align-items: center;">
                            <div style="color: #545454;">Toltal</div>
                            <div style="font-size: 4.8vw;color: #333;">${{ formatF((item.price * 1000) * item.memberNum /
                                1000) }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <el-row v-else style="text-align: center">
                <el-col :span="24" style="font-size: 5.333vw;font-weight: bold;color: #959595;">Sorry...</el-col>
                <el-col :span="24" style="font-size: 5.333vw;font-weight: bold;color: #959595;">No relevant products were
                    found</el-col>
                <el-col :span="24" style="font-size: 4.267vw;color: #959595;">Please look at other
                    products.</el-col>
                <el-col :span="24"><img style="width: 66.667vw; height: 70.933vw;" src="../assets/imgs/cart-empty.png"
                        alt=""></el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
    data() {
        return {
            drawer: false,
            drawerWidth: '90%', // Drawer宽度
            checkedOrderType: '',
            categoryList: [], //分类列表
            categoryID: [], // 分类id
            product: "", // 商品列表
            productList: "",
            total: 0, // 商品总量
            pageSize: 10, // 每页显示的商品数量
            currentPage: 1, //当前页码
            activeName: "-1", // 分类列表当前选中的id
            search: "", // 搜索条件
            brands: [],
            brands1: [
                { brand: 'Gifts For Paws' },
                { brand: 'Gigwi' },
                { brand: 'PETGEEK' },
                { brand: 'SKIPDAWG' }
            ],
            selectedIndex: null,
            categories: '',
            messages: [],
            messages1: [],
            clicks: '',
            highlightedIndex: null, // 选中的文字索引,
            brandCheckedList: [],
            brandCheckedList1: [],
            categoryCheckedList: [],
            minAmount: '',
            maxAmount: '',
            sortList: [
                { value: 'Best Sellers', label: 'Best Sellers' },
                { value: 'Newest Arrivals', label: 'Newest Arrivals' },
                { value: 'Price Low to High', label: 'Price Low to High' },
                { value: 'Price High to Low', label: 'Price High to Low' },
                { value: 'Default', label: 'Default' },
            ],
            keyword: '',
            goods: [],
            shoppingCart: [],
            isAllCheck: false,
            loading: true,
            tag: [],
            fiforckd: false,
            options: [{
                value: '1',
                label: 'Best Sellers'
            }, {
                value: '2',
                label: 'Newest Arrivals',
            }, {
                value: '3',
                label: 'Price Low to High'
            }, {
                value: '4',
                label: 'Price High to Low'
            }, {
                value: '0',
                label: 'Default'
            }],
            valuesort: ''
        }
    },
    activated() {
        this.getBrands()
    },
    mounted() {
        this.getfenlei();
    },
    computed: {
        summaryCategories: function () {
            let arr = []
            this.categories.foreach(item => {
                item.children.foreach(item => {
                    arr.push(item)
                })
            });
            return arr;
        },
    },
    // watch: {
    //     checkedOrderType: 'viewResults',
    //     tag: 'viewResults',
    //     brandCheckedList: 'viewResults',
    //     categoryCheckedList: 'viewResults',
    // },
    methods: {
        ...mapActions(["setShoppingCart", "deleteShoppingCart",]),
        handleSearch() {
            this.getGoodsList()
        },
        getBrands() {
            this.$axios
                .post("/api/mall/member/getUserBrands", {
                    id: this.$store.getters.getUser.id,
                })
                .then(res => {
                    this.brands = res.data.data
                    this.brandCheckedList1 = this.brands.map(item => item.brand)
                    this.getGoodsList()
                })
                .catch(err => {
                    return Promise.reject(err);
                });
        },
        getGoodsList() {
            this.brandCheckedList1 = this.brandCheckedList
            this.$axios.post("/api/mall/cart/list", {
                pageNum: this.keyword === '' ? this.currentPage : 1,
                pageSize: this.pageSize,
                proType: this.checkedOrderType,
                tag: this.tag,
                memberId: this.$store.getters.getUser.id,
                brands: this.brandCheckedList1,
                categoryIds: this.categoryCheckedList,
                sortType: this.valuesort,
                keyword: this.keyword,
            }).then(res => {
                this.shoppingCart = res.data.data;
                this.total = res.data.data ? res.data.data.length : 0;
                this.loading = false;
                window.scrollTo(0, 0);
            }).catch(err => {
                return Promise.reject(err);
            });
        },
        getTypeData(val) {
            this.$axios
                .post("/api/mall/cart/list", {
                    // pageNum: this.currentPage,
                    // pageSize: this.pageSize,
                    proType: val
                })
                .then(res => {
                    this.product = res.data.data.records;
                    this.total = res.data.data.total;
                })
                .catch(err => {
                    return Promise.reject(err);
                });
            this.highlightedIndex = val
        },
        goAnchor(sectionId) {
            var anchor = document.getElementById(sectionId);
            // chrome
            document.body.scrollTop = anchor.offsetTop - 280;
            // firefox
            document.documentElement.scrollTop = anchor.offsetTop - 280;
            // safari
            window.pageYOffset = anchor.offsetTop - 280;
        },
        getCategory() {
            this.$axios
                .post("/api/product/getCategory", {})
                .then(res => {
                    const val = {
                        category_id: 0,
                        category_name: "全部"
                    };
                    const cate = res.data.category;
                    cate.unshift(val);
                    this.categoryList = cate;
                })
                .catch(err => {
                    return Promise.reject(err);
                });
        },
        handleChange(currentVal, key, uid) {
            this.$axios
                .post("/api/mall/cart/updateNum", {
                    memberId: this.$store.getters.getUser.id,
                    skuId: uid,
                    num: currentVal
                }).then(res => {
                    if (res.data.code === 200) {
                        this.shoppingCart[key].memberNum = currentVal
                        this.$axios
                            .post("/api/mall/cart/" + this.$store.getters.getUser.id)
                            .then(res => {
                                if (res.data.code === 200) {
                                    // 001 为成功, 更新vuex购物车状态
                                    this.setShoppingCart(res.data.data);
                                } else {
                                    // 提示失败信息
                                    this.notifyError(res.data.message);
                                }
                            })
                            .catch(err => {
                                return Promise.reject(err);
                            });
                    }
                })
        },
        addCart() {
            let arr = []
            this.shoppingCart.map(item => {
                if (item.memberNum > 0) {
                    arr.push({
                        memberId: this.$store.getters.getUser.id,
                        skuId: item.skuId,
                        memberNum: item.memberNum
                    })
                }
            })
            this.$axios
                .post("/api/mall/cart/addCart", arr)
                .then(res => {
                    if (res.data.code === 200) {
                        this.$axios
                            .post("/api/mall/cart/" + this.$store.getters.getUser.id)
                            .then(res => {
                                if (res.data.code === 200) {
                                    // 001 为成功, 更新vuex购物车状态
                                    this.setShoppingCart(res.data.data);
                                } else {
                                    // 提示失败信息
                                    this.notifyError(res.data.message);
                                }
                            })
                            .catch(err => {
                                return Promise.reject(err);
                            });
                    } else {
                        // 提示失败信息
                        this.notifyError(res.data.message);
                    }
                })
                .catch(err => {
                    return Promise.reject(err);
                });
        },
        getfenlei() {
            this.$axios
                .post("/api/mall/category/all")
                .then(res => {
                    this.categories = res.data.data
                })
                .catch(err => {
                    return Promise.reject(err);
                });
        },
        getData() {
            this.$axios
                .post("/api/mall/cart/list", {
                    pageNum: this.currentPage,
                    pageSize: this.pageSize
                })
                .then(res => {
                    this.product = res.data.data.records;
                    this.total = res.data.data.total;
                })
                .catch(err => {
                    return Promise.reject(err);
                });


        },
        // 通过搜索条件向后端请求商品数据
        getProductBySearch() {
            this.$axios
                .post("/api/mall/cart/list", {
                    pageNum: this.currentPage,
                    pageSize: this.pageSize,
                    name: this.search
                })
                .then(res => {
                    this.product = res.data.data.records;
                    this.total = res.data.data.total;
                })
                .catch(err => {
                    return Promise.reject(err);
                });
        },
        selectbrands(index) {
            this.selectedIndex = index === this.selectedIndex ? null : index;
        },
        getLabelForStatus(status) {
            switch (status) {
                case 0:
                    return this.$t('list.instock');
                case 1:
                    return this.$t('list.production');
                case 2:
                    return this.$t('list.ordertogether');
                default:
                    return 'unknown';
            }
        },
        formatF(value) {
            let value1 = Math.round(parseFloat(value) * 100) / 100;
            let s = value.toString().split(".");
            if (s.length == 1) {
                value1 = value.toString() + ".00";
                return value1;
            }
            if (s.length > 1) {
                if (s[1].length < 2) {
                    value1 = value.toString() + "0";
                }
                return value1;
            }
        },
        addOrder() {
            let arr = []
            this.shoppingCart.map(item => {
                if (item.memberNum > 0) {
                    arr.push({
                        skuId: item.skuId,
                        num: item.memberNum
                    })
                }
            })
            this.$axios
                .post("/api/mall/order/quick/" + this.$store.getters.getUser.id, arr)
                .then(res => {
                    switch (res.data.code) {
                        // “001”代表结算成功
                        case 200:
                            for (let i = 0; i < arr.length; i++) {
                                this.handleChange(0, i, arr[i].skuId)
                            }
                            // 提示结算结果
                            this.notifySucceed("下单成功");
                            // 跳转我的订单页面
                            this.$router.push({ path: "/order" });
                            break;
                        default:
                            // 提示失败信息
                            this.notifyError(res.data.message);
                    }
                })
                .catch(err => {
                    return Promise.reject(err);
                });
        },
        clearFilters() {
            this.checkedOrderType = ''
            this.tag = []
            this.brandCheckedList = []
            this.categoryCheckedList = []
            this.getGoodsList()
            this.drawer = false
        },
        viewResults() {
            if (this.checkedOrderType !== '' ||
                this.tag !== '' ||
                this.brandCheckedList.length !== 0 ||
                this.categoryCheckedList.length !== 0) {
                this.fiforckd = true
            } else {
                this.fiforckd = false
            }
        },
        cancel(e) {
            if (this.checkedOrderType === e) {
                this.checkedOrderType = null
            } else {
                this.checkedOrderType = e
            }
            this.getGoodsList()
        },
        cancel1(e) {
            if (this.tag === e) {
                this.tag = null
            } else {
                this.tag = e
            }
            this.getGoodsList()
        }
    },
}
</script>

<style scoped>
.order {
    font-size: 16px;
    border-top: 1px solid #c7c7c7;
    margin-top: -1px;
}

.top {
    position: fixed;
    z-index: 2;
    padding: 18px 29px 12px;
    width: 100%;
    border-bottom: 1px solid #D9D9D9;
    background-color: #fff;
}

.filter {
    width: 153px;
    height: 37px;
    padding: 0 10.8px 0 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #c7c7c7;
    border-radius: 10px;
    border: 1px solid #959595;
}

.filter img {
    width: 10px;
    height: 10px;
}

.sort {
    width: 153px;
    height: 37px;
}

::v-deep .sort .el-input__inner {
    width: 153px;
    height: 37px;
    border-color: #b1b1b1;
    border-radius: 10px;
}

::v-deep .sort .el-select-dropdown__item.selected {
    color: #CA141D;
}

.brand-item,
.category-item {
    display: block;
    margin-bottom: 18px;
}

::v-deep .el-drawer__header {
    padding: 35px 30px 24px;
    margin-bottom: 0;
    color: #CA141D;
    font-weight: bold;
}

::v-deep [class*=" el-icon-"] {
    font-weight: bold;
}

::v-deep .el-radio {
    color: #333;
}

::v-deep .el-checkbox {
    color: #333;
}

::v-deep .el-breadcrumb__inner.is-link:hover {
    color: #000;
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #333;
    border-color: #333;
}

::v-deep .el-radio__input.is-checked .el-radio__inner {
    border-color: #333;
    background: #333;
}

::v-deep .el-radio__label {
    font-size: 14px;
}

::v-deep .el-checkbox__label {
    font-size: 14px;
}

::v-deep .el-radio__input.is-checked+.el-radio__label {
    color: #333;
    font-weight: bold;
}

::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #333;
    font-weight: bold;
}

::v-deep .el-select .el-input.is-focus .el-input__inner {
    border-color: #333;
}

::v-deep .el-checkbox {
    -webkit-tap-highlight-color: transparent !important;
}

::v-deep .el-input__inner:focus {
    border-color: #333;
}

::v-deep .el-radio__inner:hover {
    border-color: #333;
}

::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #333;
}

::v-deep .el-checkbox__inner:hover {
    border-color: #333;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #000;
    color: #FFF;
}

::v-deep .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
    -webkit-box-shadow: 0 0 0px 0px transparent;
    box-shadow: 0 0 0px 0px transparent;
}

::v-deep .el-input-number__increase:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled) {
    border-color: #B4BAC1;
}

::v-deep .el-input-number__decrease:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled),
.el-input-number__increase:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled) {
    border-color: #B4BAC1;
}

::v-deep .el-input-number__increase:hover {
    color: #B4BAC1;
}

::v-deep .el-input-number__decrease:hover {
    color: #B4BAC1;
}

.title {
    font-weight: bold;
    margin: 20px 0;
}

.filterbtn {
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 0 30px;
    background-color: #CA141D;
    width: 337.5px;
    height: 83px;
    z-index: 3;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.filterbtn div {
    font-size: 14px;
    width: 120px;
    height: 36px;
    border-radius: 7px;
    background-color: #fff;
}

.filterbtn .left {
    background-color: #FB9A9F;
    color: #CA141D;
    display: flex;
    justify-content: center;
    align-items: center;
}

.filterbtn .right {
    background-color: #FFF;
    color: #CA141D;
    display: flex;
    justify-content: center;
    align-items: center;
}

.toysItem {
    width: 40.693vw;
    height: 102.133vw;
    border-radius: 3.2vw;
    border: 1px solid #D9D9D9;
    margin-right: 3.2vw;
    margin-bottom: 4.267vw;
    position: relative;
}

.off {
    position: absolute;
    top: 0;
    left: 0;
    width: 15.733vw;
    height: 6.133vw;
    font-size: 2.667vw;
    font-weight: bold;
    border-radius: 3.2vw 0 3.2vw 0;
    color: #FFF;
    background-color: #FF764B;
    display: flex;
    justify-content: center;
    align-items: center;
}

.NEW {
    position: absolute;
    top: 0;
    left: 0;
    width: 10.667vw;
    height: 6.667vw;
    font-size: 2.667vw;
    font-weight: bold;
    border-radius: 3.2vw 0 3.2vw 0;
    color: #FFF;
    background-color: #52DD79;
    display: flex;
    justify-content: center;
    align-items: center;
}

.Purchased {
    position: absolute;
    top: 0;
    left: 7.467vw;
    padding-left: 3.2vw;
    width: 20vw;
    height: 6.667vw;
    font-size: 2.4vw;
    font-weight: bold;
    border-radius: 4vw 0 4vw 0;
    color: #FFF;
    background-color: #4583E1;
    display: flex;
    justify-content: center;
    align-items: center;
}

.tp {
    position: absolute;
    top: 5px;
    right: 5px;
    width: 10.667vw;
    height: 4vw;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 7px;
    font-weight: bold;
    border: 1px solid #333;
    border-radius: 14px;
}

.toysItem:nth-child(2n) {
    margin-right: 0px;
}

.skuname {
    color: #333;
    font-weight: bold;
    text-align: center;
    height: 14.565vw;
    padding-bottom: 12.6px;
    margin-top: 2.667vw;
    border-bottom: 1px solid #D9D9D9;
}

.parameterItem {
    font-size: 12px;
    height: 50px;
    padding: 8px 0;
    color: #6D6D6D;
    border-bottom: 1px solid #D9D9D9;
}</style>